<template>
  <div class="upload-wrapper mt-10">
    <div v-if="prop.meta && prop.meta.imgUrl">
       Members Photo
      <el-tooltip effect="dark" content="If you do not want your profile photo to display on the live score platform please turn this switch off." placement="top-start">
        <i class="el-icon-info info"/>
      </el-tooltip>
    </div>
    <div v-if="!edit" class="avatar-section">
      <el-avatar
      class="d-flex flex-justify-center flex-align-items-center avatar"
      icon="el-icon-picture"
      :src="currentImageUrl"
      :key="`avatar-${key}-${imageTimestamp}`"
      :size="120"></el-avatar>
    </div>
      <div class="avatar-edit" v-if="prop.meta && prop.meta.imgUrl && edit === true">
        <cropper
        ref="cropper"
        :src="cleanImageUrl"
        :key="`cropper-${key}-${imageTimestamp}`"
        @change="change"
        :stencil-props="{
          previewClass: 'test-preview'
        }"
        :stencil-component="$options.components.Stencil"
        />
        <div class="button-container text-center m-10">
          <el-button type="secondary" class="btn btn-secondary" @click.prevent="edit=false">Cancel</el-button>
          <el-button type="primary" class="btn btn-primary" @click.prevent="saveCroppedImage()">Save</el-button>
        </div>
      </div>
    <div class="d-flex flex-justify-center" v-if="type === 'members' && prop.meta && prop.meta.imgUrl">
      <el-form-item>
        <el-switch
          v-model="prop.meta.showImg"
          active-color="#13ce66"
          inactive-color="#ff4949"
          active-text="Yes"
          inactive-text="No"
          @change="updateImageVisibility"
        >
        </el-switch>
      </el-form-item>
    </div>
    <div class="d-flex justify-content-center w-100" v-if="!edit">
      <vue-upload-component
      ref="upload"
      :drop=true
      v-model="files"
      :extensions="extensions"
      :accept="accept"
      :post-action="uploadURL"
      :headers="uploadHeaders"
      :data="entityData"
      :multiple=true
      @input-file="inputFile"
      @input-filter="inputFilter"
      class="el-button el-button--primary upload-button">
      Upload
      </vue-upload-component>
      <el-button icon="el-icon-delete" class="deletes-button" @click="removeImage" v-if="prop.meta && prop.meta.imgUrl"></el-button>
      <el-button icon="el-icon-edit" class="delete-button" @click="edit=true" v-if="prop.meta && prop.meta.imgUrl"></el-button>
    </div>
  </div>
</template>

<script>
import { errormsg, uploadURL } from '@/utils/constants';
import _ from 'lodash';
import { Cropper } from 'vue-advanced-cropper';
import Stencil from './Stencil.vue';

import 'vue-advanced-cropper/dist/style.css';

export default {
  name: 'UploadItem',
  props: {
    prop: Object,
    type: String,
    label: String
  },
  components: {
    Cropper,
    // eslint-disable-next-line vue/no-unused-components
    Stencil
  },
  data() {
    return {
      uploadURL,
      files: [],
      key: 0,
      accept: 'image/png,image/jpg,image/jpeg,image/heic',
      extensions: 'jpg,jpeg,png',
      edit: false,
      editImage: '',
      canvas: null,
      imageTimestamp: Date.now()
    };
  },
  computed: {
    uploadHeaders() {
      return this.$store.getters['user/uploadHeaders'];
    },
    entityData() {
      return { _id: this.prop._id, type: this.type };
    },
    currentImageUrl() {
      const baseUrl = this.prop.meta?.imgUrl;
      console.log('currentImageUrl computed - baseUrl:', baseUrl);
      console.log('currentImageUrl computed - imageTimestamp:', this.imageTimestamp);
      console.log('currentImageUrl computed - key:', this.key);
      if (!baseUrl) {
        console.log('currentImageUrl: No base URL, returning empty string');
        return '';
      }
      const finalUrl = `${baseUrl.split('?')[0]}?v=${this.imageTimestamp}&k=${this.key}`;
      console.log('currentImageUrl final URL:', finalUrl);
      return finalUrl;
    },
    cleanImageUrl() {
      const baseUrl = this.prop.meta?.imgUrl;
      if (!baseUrl) return '';
      return baseUrl.split('?')[0];
    }
  },
  mounted() {
    console.log('UploadItem mounted - initial prop:', this.prop);
    console.log('UploadItem mounted - initial imgUrl:', this.prop.meta?.imgUrl);
  },
  methods: {
    change({ canvas }) {
      this.canvas = canvas;
    },

    saveCroppedImage() {
      // const file = this.files[0];
      // upload cropped image
      this.$nextTick(() => {
        const form = new FormData();
        this.canvas.toBlob((blob) => {
          let originalname = '';
          if (_.get(this.files, '[0].name')) {
            originalname = this.files[0].name;
          } else {
            originalname = this.prop.meta.imgUrl.split('/').pop();
          }
          const file = new File([blob], originalname, { type: 'image/png' });
          form.append('file', file);
          form.append('_id', this.prop._id);
          form.append('type', this.type);
          this.$store.commit('loading', { loading: true, text: 'Loading...' });
          this.$http.post('/assemble/api/v1/portal/logos/upload', form).then((res) => {
            this.$store.commit('loading', false);
            this.$message.success('Image uploaded successfully');

            console.log('Full API response:', res);
            console.log('API response data:', res.data);

            // Try different possible URL properties from the API response
            const imgUrl = res.data.resize || res.data.fullsize || res.data.original || res.data.thumbnail;
            const timestamp = this.moment().valueOf();

            console.log('New image URL from API (resize):', imgUrl);
            console.log('Alternative URLs from API:', {
              fullsize: res.data.fullsize,
              thumbnail: res.data.thumbnail,
              original: res.data.original
            });
            console.log('Old image URL:', this.prop.meta?.imgUrl);

            if (!this.prop.meta) {
              this.$set(this.prop, 'meta', {});
            }

            // Force reactivity with $set and update the URL with fresh timestamp
            this.$set(this.prop.meta, 'imgUrl', imgUrl);
            console.log('Updated image URL:', this.prop.meta.imgUrl);

            // Update the stable timestamp for cache busting AFTER setting imgUrl
            this.imageTimestamp = timestamp;

            // Force component re-render by updating key
            this.key++;

            // Use nextTick to ensure DOM updates before hiding edit mode
            this.$nextTick(() => {
              // Force update again after DOM changes
              this.$forceUpdate();
              this.edit = false;
              // Emit event to parent to refresh any other image displays
              this.$emit('imageUpdated', { imgUrl, timestamp });

              // Additional force update after a short delay to ensure cache-busting takes effect
              setTimeout(() => {
                this.$forceUpdate();
                console.log('Final force update - URL should be:', this.prop.meta.imgUrl);
              }, 100);
            });

            this.$emit('input', res.data);
          }).catch((err) => {
            this.$store.commit('loading', false);
            this.$message.error(err);
          });
        }, 'image/jpeg', 1);
      });
    },
    inputFile(newFile, oldFile) {
      if (newFile && oldFile && !newFile.active && oldFile.active) {
        if (newFile.response.status === 'success') {
          const imgUrl = newFile.response.fullsize;
          const timestamp = this.moment().valueOf();

          console.log('Regular upload - New image URL from API:', imgUrl);
          console.log('Regular upload - Old image URL:', this.prop.meta?.imgUrl);

          if (!this.prop.meta) {
            this.$set(this.prop, 'meta', {});
          }

          // Use $set for better reactivity
          this.$set(this.prop.meta, 'imgUrl', imgUrl);
          console.log('Regular upload - Updated image URL:', this.prop.meta.imgUrl);

          // Update the stable timestamp for cache busting AFTER setting imgUrl
          this.imageTimestamp = timestamp;

          this.$message.success('Successful');
          this.$store.commit('loading', false);
          this.key++;

          // Force update after state changes
          this.$nextTick(() => {
            this.$forceUpdate();
            // Emit event to parent to refresh any other image displays
            this.$emit('imageUpdated', { imgUrl, timestamp });
          });
        } else {
          this.$store.commit('loading', false);
          this.$message.error('Error uploading file');
        }
      }
    },
    inputFilter(newFile, oldFile, prevent) {
      if (!/\.(png|jpg|jpeg)$/i.test(newFile.name)) {
        this.$message.error(errormsg.image_format);
        return prevent();
      }
      // 5mb limit
      if (newFile.size > 1024 * 1024 * 5) {
        this.$message.error(errormsg.file_size);
        return prevent();
      }
      this.$refs.upload.active = true;
      this.$store.commit('loading', { loading: true, text: 'Loading...' });
      return true;
    },
    removeImage() {
      this.$confirm('Are you sure you want to remove this image?', 'Warning')
        .then(() => {
          delete this.prop.meta.imgUrl;
          const { _id } = this.prop;
          this.$http
            .post('/assemble/api/v1/portal/logos/unset', { _id, type: this.type })
            .then(() => {
              this.$store.commit('loading', false);
              this.$message.success('Successful');
              this.key++;
            })
            .catch(() => {
              this.$store.commit('loading', false);
              this.$message.error('Error uploading file');
            });
        })
        .catch(() => {});
    },
    updateImageVisibility(status) {
      this.$emit('updateImageVisibility', status);
    }
  },
  watch: {
    // Watch for prop changes to ensure reactivity
    'prop.meta.imgUrl': {
      handler(newUrl, oldUrl) {
        if (newUrl && newUrl !== oldUrl) {
          this.imageTimestamp = Date.now();
          this.key++;
          this.$nextTick(() => {
            this.$forceUpdate();
          });
        }
      },
      immediate: false
    }
  }

};
</script>

<style lang="scss" scoped>
.upload-wrapper {
  display: flex;
  gap: 1rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;

  @media (max-width: 768px) {
    gap: 1.5rem;
    padding: 1rem;
  }
  .avatar-edit{
    width: 400px;
    height: 400px;
    max-width: 100%;
    max-height: 60vh;
    .test-preview {
      border: dashed 1px rgba(255,255,255, 0.25);
    }

    // Mobile responsive adjustments
    @media (max-width: 768px) {
      width: 100%;
      height: 300px;
      margin-bottom: 1rem;
    }

    @media (max-width: 480px) {
      height: 250px;
      margin-bottom: 1.5rem;
    }

    .button-container {
      position: relative;
      z-index: 10;
      background: white;
      padding: 1rem;
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

      @media (max-width: 768px) {
        margin-top: 1rem;
        margin-bottom: 2rem;
        padding: 1.5rem;

        .btn {
          width: 100%;
          margin: 0.25rem 0;
        }
      }
    }
  }

    // Toggle switch container spacing
  .d-flex.flex-justify-center {
    margin-top: 1rem;
    margin-bottom: 1rem;
    position: relative;
    z-index: 5;

    @media (max-width: 768px) {
      margin-top: 2rem;
      margin-bottom: 2rem;
      padding: 1rem 0;
    }

    .el-form-item {
      margin-bottom: 0;
    }
  }
}

 .avatar-section {
    overflow: hidden;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    // margin-bottom: 1.5rem;
    .avatar {
    //   background-color: transparent !important;
      font-size: 5.5rem;
      display: flex;
      justify-content: center;
      align-items: center;
      color: $primary !important;
    }
  }

  .upload-button {
    display: flex;
    justify-content: center;
    width: 7.5rem;
  }

  .delete-button {
    width: 7.5rem;
  }

  .label-margin {
    margin-left: 45px;
  }

::v-deep .copy .el-input-group__append {
  background-color: $highlight !important;
  border-color: $highlight !important;
  color: white;
}
::v-deep .vue-preview--fill{

  border: dashed 1px rgba(255,255,255, 0.25);
}
</style>
<style scoped>

</style>
